export default {
  gameBRoute: {
    loadFailed: "加载失败",
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    opSuccess: "操作成功",
    deleteSuccess: "删除成功",
    deleteConfirm: "确认删除该映射？删除不可恢复",
    addTitle: "新增 B 线路游戏映射",
    editTitle: "编辑 B 线路游戏映射",
    selectAPlatformFirst: "请先选择 A 线路平台",
    aPlatformRequired: "请选择 A 线路平台编码",
    aGameRequired: "请选择 A 线路游戏编码",
    bPlatformRequired: "请选择 B 线路平台编码",
    bPlatformPh: "请选择 B 线路平台编码",
    bGameCodeHint: "可为空（大厅游戏，为空则进 B 平台沿用原游戏编码）",
    col: {
      aPlatformCode: "A线路平台编码",
      aGameCode: "A线路游戏编码",
      bPlatformCode: "B线路平台编码",
      bGameCode: "B线路游戏编码",
      status: "状态",
      createTime: "创建时间",
      action: "操作"
    },
    status: { enabled: "启用", disabled: "禁用" },
    btn: { search: "搜索", reset: "重置", add: "新增映射", edit: "编辑", delete: "删除", enable: "启用", disable: "禁用" }
  },
  common: {
    button: {
      save: "保存",
      back: "返回",
      add: "新增",
      edit: "修改",
      delete: "删除"
    },
    queryFrm: {
      search: "查询",
      reset: "重置"
    }
  },
  smsSupplyMgmt: {
    title: "短信服务商",
    countryName: "国家名称",
    countryCode: "国家区号",
    smsSupplyName: "短信服务商",
    operation: "操作",
    enable: "开",
    disable: "关",
    confirmOperation: "确认操作",
    enableAction: "启用",
    disableAction: "禁用",
    confirmEnable: "确定要启用短信服务商",
    confirmDisable: "确定要禁用短信服务商",
    enableSuccess: "启用成功",
    disableSuccess: "禁用成功",
    enableFailed: "启用失败",
    disableFailed: "禁用失败",
    fetchDataFailed: "获取数据失败",
    fetchCountryDataFailed: "获取国家数据失败",
    loading: "加载中...",
    unknown: "未知",
    bottomTip: "一个国家只能一个短信服务商",
    paginationTotal: "共 {{total}} 条记录，第 {{start}}-{{end}} 条"
  },
  gameEntryMgmt: {
    customCategoryManagement: "自定义分类管理",
    gamePlatformManagement: "游戏平台管理",
    gameLine: "游戏线路",
    customGameType: "自定义游戏类型",
    systemPlatformCategory: "系统平台分类",
    currency: "货币",
    isEnabled: "是否启用",
    gamePlatformName: "游戏平台名称",
    isMaintenance: "是否维护",
    yes: "是",
    no: "否",
    operation: "操作",
    add: "新增",
    edit: "修改",
    delete: "删除",
    enable: "启用",
    disable: "禁用",
    maintenance: "维护",
    refresh: "刷新",
    sort: "排序",
    selectGameLine: "请选择线路",
    selectCurrency: "请选择币种",
    selectStatus: "请选择状态",
    selectMaintenanceStatus: "请选择维护状态",
    pleaseInputSort: "请输入排序",
    selectCustomGameCategory: "请选择自定义游戏分类",
    selectGamePlatformCategory: "请选择游戏平台分类",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    confirmMessage: "是否删除",
    confirmDisable: "是否禁用",
    confirmEnable: "是否启用",
    refreshSuccess: "刷新成功",
    dataLoadFailed: "数据加载失败"
  },
  gameHotMgmt: {
    hotGameList: "热门游戏列表",
    hotGameLangList: "热门游戏语言列表",
    displayMethod: "展示方式",
    platformName: "平台名称",
    gameName: "游戏名称",
    gameLine: "游戏线路",
    currency: "货币",
    sort: "排序",
    manualSort: "手动排序",
    autoSort: "自动排序",
    isEnabled: "是否启用",
    yes: "是",
    no: "否",
    confirmDisable: "是否禁用",
    confirmEnable: "是否启用",
    confirmDelete: "是否删除",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    dataLoadFailed: "数据加载失败",
    add: "新增",
    edit: "修改",
    hotGame: "热门游戏",
    language: "语言",
    entryImage: "入口图片",
    uploadEntryImage: "未上传入口图片",
    gamePlatform: "游戏平台",
    game: "游戏",
    customGameCategory: "自定义游戏分类",
    pleaseSelectDisplayMethod: "请选择展示方式",
    pleaseSelectLine: "请选择线路",
    pleaseSelectCustomGameCategory: "请选择自定义游戏分类",
    pleaseSelectGamePlatform: "请选择游戏平台",
    pleaseSelectGame: "请选择游戏",
    pleaseInputSort: "请输入排序",
    pleaseSelectLanguage: "请选择语言",
    pleaseSelectHotGame: "请选择热门游戏",
    pleaseSelectStatus: "请选择状态",
    pleaseInputGameName: "请输入游戏名称",
    pleaseInputPlatformName: "请输入平台名称",
    setMultiLanguage: "设置多语言",
    formValidationFailed: "表单验证失败",
    addSuccess: "新增成功",
    editSuccess: "修改成功",
    icon: "图标",
    status: "状态",
    enabled: "启用",
    disabled: "禁用",
    pleaseSelectCurrency: "请选择币种"
  },
  gameListMgmt: {
    gameMainData: "游戏主数据",
    gameLangData: "语言数据",
    platformCategory: "平台分类",
    gamePlatform: "游戏平台",
    gameName: "游戏名称",
    gameCode: "游戏编码",
    sort: "排序",
    manualSort: "手动排序",
    autoSort: "自动排序",
    effectMode: "生效方式",
    isPcSupported: "是否支持PC",
    isH5Supported: "是否支持H5",
    displayName: "显示名称",
    gameEntryIcon: "游戏入口图标",
    batchAdd: "批量新增",
    save: "保存",
    back: "返回",
    setMultiLanguage: "设置多语言",
    addGameLangData: "新增语言游戏数据",
    editGameLangData: "编辑语言游戏数据",
    gameSystemName: "游戏系统名称",
    language: "语言",
    confirmDelete: "是否删除",
    confirmEnable: "是否启用",
    confirmDisable: "是否禁用",
    pleaseSelectCategory: "请选择分类",
    pleaseSelectPlatform: "请选择平台",
    pleaseInputGameName: "请输入游戏名称",
    pleaseInputGameCode: "请输入游戏编码",
    pleaseInputSort: "请输入排序",
    pleaseSelectPcSupport: "请勾选是否支持PC",
    pleaseSelectH5Support: "请勾选是否支持H5",
    pleaseInputDisplayName: "请输入显示名称",
    pleaseSelectLanguage: "请选择语言",
    addSuccess: "新增成功",
    editSuccess: "修改成功",
    formValidationFailed: "表单验证失败",
    dataLoadFailed: "数据加载失败",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    uploadImgStatus: "图片状态",
    pleaseSelectIsUploadImg: "全部",
    uploadImage: "已上传",
    noUploadImage: "未上传",
    highRiskGame: "高风险游戏",
    highRiskConfig: "高风险游戏",
    highRiskNo: "否",
    highRiskYes: "是",
    highRiskFilterAll: "全部",
    tagImg: "游戏标签",
    uploadNeedGameInfo: "请先选择游戏平台与游戏（或填写游戏代码）后再上传图片",
    tagImgHint: "尺寸 64 × 40 像素，体积上限 50 KB",
    notConfigured: "未配置",
    h5Image: "H5 图片（手机端使用）",
    pcImage: "PC 图片（台式机端使用）",
    h5ImageHint: "手机 H5 客户端用此图",
    pcImageHint: "线下门店台式机 / PC 端用此图",
    missingH5: "缺 H5（手机端）",
    missingPc: "缺 PC（台式机端）",
    imgStatusAll: "全部",
    imgStatusH5Only: "仅 H5（缺台式机）",
    imgStatusPcOnly: "仅 PC（缺手机）",
    imgStatusBoth: "两套都有",
    imgStatusNone: "两套都缺",
    currency: "币种",
    pleaseSelectCurrency: "请选择币种"
  },
  gamePlatformMgmt: {
    mainData: "平台主数据",
    languageData: "语言数据",
    currencyData: "币种数据",
    platformName: "平台名称",
    platformKey: "平台标识",
    platformType: "平台类型",
    platformCategory: "平台分类",
    platform: "平台",
    platformDisplayName: "平台显示名称",
    platformDesc: "平台描述",
    platformMaintainNotice: "维护公告",
    platformLogo: "平台 Logo",
    platformEntryIcon: "平台入口图标",
    platformCurrency: "平台币种",
    language: "语言",
    currency: "币种",
    displayName: "显示名称",
    addPlatformLangData: "新增语言平台数据",
    setMultiLanguage: "设置多语言",
    pleaseInputPlatformName: "请输入平台名称",
    pleaseInputPlatformKey: "请输入平台标识",
    pleaseSelectPlatformType: "请选择平台类型",
    pleaseSelectPlatformCategory: "请选择平台分类",
    pleaseSelectPlatform: "请选择平台",
    pleaseInputDisplayName: "请输入显示名称",
    pleaseInputPlatformDesc: "请输入平台描述",
    pleaseInputMaintainNotice: "请输入维护公告",
    pleaseSelectLanguage: "请选择语言",
    pleaseSelectCurrency: "请选择币种",
    dataLoadFailed: "数据加载失败",
    formValidationFailed: "表单验证失败",
    addSuccess: "新增成功",
    editSuccess: "修改成功",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    confirmDeletePlatform: "确认是否删除平台",
    confirmDeletePlatformCurrency: "确认是否删除平台币种",
    column: {
      title: {
        index: "序号",
        gamePlatformName: "平台名称",
        gamePlatformCode: "平台编码",
        bRouteCode: "B线路平台编码",
        gameType: "平台类型",
        desc: "描述",
        gameFullName: "平台全称",
        gameShowName: "显示名称",
        action: "操作",
        platformName: "平台名称",
        platformType: "平台类型",
        currency: "币种"
      }
    }
  },
  // 游戏线路名称映射（后端仅存中文名，以中文原名为键）
  gameLineName: {
    "美国": "美国",
    "墨西哥": "墨西哥",
    "菲律宾": "菲律宾"
  },
  // 游戏品类名称映射（dict 31004/31005 仅存中文 itemName，以中文原名为键）
  gameCategoryName: {
    "电子": "电子",
    "真人": "真人",
    "体育": "体育",
    "彩票": "彩票",
    "捕鱼": "捕鱼",
    "棋牌": "棋牌",
    "电竞": "电竞",
    "小游戏": "小游戏",
    "竞猜": "竞猜",
    "街机": "街机",
    "宾果": "宾果"
  },
  gamePromotMgmt: {
    mainPromotGamePlatform: "主推电子游戏平台",
    entryImage: "入口图片",
    platform: "线路",
    gamePlatform: "游戏平台",
    currency: "币种",
    sort: "排序",
    status: "状态",
    enabled: "启用",
    disabled: "禁用",
    add: "新增",
    edit: "修改",
    delete: "删除",
    confirmDelete: "是否删除",
    confirmDisable: "是否禁用",
    confirmEnable: "是否启用",
    addSuccess: "新增成功",
    editSuccess: "修改成功",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    dataLoadFailed: "数据加载失败",
    formValidationFailed: "表单验证失败",
    pleaseSelectPlatform: "请选择线路",
    pleaseSelectGamePlatform: "请选择游戏平台",
    pleaseInputSort: "请输入排序",
    pleaseSelectCurrency: "请选择币种",
    pleaseSelectStatus: "请选择状态",
    column: {
      title: {
        index: "序号",
        platformName: "平台名称",
        gamePlatformName: "游戏平台名称",
        gameLine: "游戏线路",
        currency: "货币",
        sort: "排序",
        status: "状态",
        action: "操作"
      }
    }
  },
  gameRecMgmt: {
    mainGameList: "主推游戏列表",
    mainGameLangList: "主推游戏语言列表",
    displayMethod: "展示方式",
    platformName: "平台名称",
    gameName: "游戏名称",
    gameLine: "游戏线路",
    currency: "币种",
    sort: "排序",
    manualSort: "手动排序",
    autoSort: "自动排序",
    status: "状态",
    enabled: "启用",
    disabled: "禁用",
    add: "新增",
    edit: "修改",
    delete: "删除",
    confirmDelete: "是否删除",
    confirmDisable: "是否禁用",
    confirmEnable: "是否启用",
    addSuccess: "新增成功",
    editSuccess: "修改成功",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    dataLoadFailed: "数据加载失败",
    formValidationFailed: "表单验证失败",
    pleaseSelectPlatform: "请选择线路",
    pleaseSelectGamePlatform: "请选择游戏平台",
    pleaseInputSort: "请输入排序",
    pleaseSelectCurrency: "请选择币种",
    pleaseSelectStatus: "请选择状态",
    pleaseSelectLanguage: "请选择语言",
    pleaseSelectGame: "请选择游戏",
    pleaseSelectCustomGameCategory: "请选择自定义游戏分类",
    entryImage: "入口图片",
    uploadEntryImage: "未上传入口图片",
    gamePlatform: "游戏平台",
    game: "游戏",
    customGameCategory: "自定义游戏分类",
    language: "语言",
    setMultiLanguage: "设置多语言",
    column: {
      title: {
        index: "序号",
        platformName: "平台名称",
        gamePlatformName: "游戏平台名称",
        gameName: "游戏名称",
        gameLine: "游戏线路",
        currency: "币种",
        sort: "排序",
        status: "状态",
        action: "操作",
        icon: "图标",
        language: "语言"
      }
    }
  },
  gameTypeMgmt: {
    editType: "编辑类型",
    type: "类型",
    typeRequired: "请输入类型",
    pleaseInputType: "请输入类型",
    gamePlatform: "游戏平台",
    pleaseSelectGamePlatform: "请选择游戏平台",
    icon: "图标",
    uploadIconRequired: "请上传图标",
    menuIcon: "菜单图标",
    updateSuccess: "更新成功",
    updateFailed: "更新失败",
    language: "语言",
    pleaseSelectLanguage: "请选择语言",
    yes: "是",
    no: "否",
    dataLoadFailed: "数据加载失败",
    operationSuccess: "操作成功",
    operationFailed: "操作失败",
    column: {
      title: {
        index: "序号",
        gameGroupName: "游戏组名称",
        gameStatus: "游戏状态",
        operateAction: "操作",
        language: "语言",
        icon: "图标",
        menuIcon: "菜单图标"
      }
    }
  },
  gameModuleMgmt: {
    yes: "是",
    no: "否",
    pageTitle: "客户端模块管理",
    line: "线路",
    language: "语言",
    selectLine: "请选择线路",
    selectLanguage: "请选择语言",
    clientTab: "客户端 Tab",
    modulesCount: "{{count}} 个模块",
    moduleListTitle: "Tab · 模块列表（共 {{count}} 个模块）",
    selectTabHint: "请先选择线路、语言后再点选 Tab",
    systemLocked: "🔒 系统模块（不可配置）",
    jumpToSource: "⚙ 跳转源菜单",
    addModule: "+ 新增模块",
    editModule: "编辑模块",
    configGame: "⚙ 配置游戏",
    back: "返回",
    confirmDelete: "确认删除该模块？",
    addSuccess: "新增成功",
    editSuccess: "编辑成功",
    deleteSuccess: "删除成功",
    platformOrTabRequired: "请先选择线路与 Tab",
    manualSort: "手动排序",
    autoSort: "自动排序",
    autoSortRule: "自动排序规则",
    resetDate: "重置日期",
    resetTime: "重置时间",
    daily: "每日",
    weekly: "每周",
    column: {
      sort: "排序",
      autoSortRule: "自动排序规则",
      icon: "Icon",
      label: "标签",
      name: "模块名称",
      isSystem: "是否系统",
      status: "状态",
      action: "操作"
    },
    add: { title: "新增模块" },
    edit: { title: "编辑模块" },
    form: {
      sort: "排序",
      sortRequired: "请输入排序",
      sortMustBeInteger: "排序必须为整数",
      moduleName: "模块名称",
      moduleNameRequired: "请输入模块名称",
      iconUrl: "模块 Icon",
      iconUrlRequired: "请上传模块 Icon",
      gameLabelUrl: "游戏标签",
      remark: "备注",
      remarkPlaceholder: "可填写模块规则、数据来源、运营注意事项等",
      langSelect: "语言",
      langSelectRequired: "请选择语言",
      langHint: "⚙ 模块名称 / Icon / 游戏标签 / 备注 按语言独立维护",
      displayRows: "展示行数",
      displayRowsRequired: "请选择展示行数",
      displayRows1: "1*3（1行/3个）",
      displayRows2: "2*3（2行/6个）",
      displayRows3: "3*3（3行/9个）",
      displayRowsKiosk1: "1*7（1行/7个）",
      displayRowsKiosk2: "2*7（2行/14个）",
      displayRowsKiosk3: "3*7（3行/21个）"
    },
    gameConfig: {
      module: "模块",
      attached: "已挂",
      attachedCount: "{{count}} 款",
      addGame: "新增",
      batchRemove: "批量移除",
      remove: "移除",
      confirmRemove: "确认从本模块移除该游戏？",
      confirmBatchRemove: "确认从本模块移除已选 {{count}} 款游戏？",
      removeSuccess: "已移除",
      selectAtLeastOne: "请至少选择一款"
    },
    gameAdd: {
      title: "从「子游戏设置」选择游戏挂载到本模块",
      index: "序号",
      gameType: "平台分类",
      gamePlatform: "游戏平台",
      gameName: "游戏名称",
      gameNamePlaceholder: "请输入游戏名称",
      selectGameType: "请选择平台分类",
      selectGamePlatform: "请选择游戏平台",
      platformRequired: "请先选择游戏平台",
      selectAtLeastOne: "请至少勾选一款游戏",
      addSuccess: "添加成功"
    }
  },
  desktopGameModuleMgmt: {
    pageTitle: "台式机模块管理",
    desktopTab: "台式机 Tab",
    copyFromClient: "从客户端复制",
    copyFromClientHint: "台式机模块与客户端模块管理独立存储；可一键从客户端复制全部分组的配置作为起点。",
    copyFromClientConfirm: "确认从客户端复制全部分组？系统模块按编码去重不会重复；自定义模块仅在该分组为空时整组复制；均不会覆盖现有数据。",
    copyFromClientResult: "已复制 {{count}} 个模块",
    selectLineFirst: "请先选择线路"
  }
};
